import PageLayout from "@/components/PageLayout";
import { STUDIO } from "@/lib/site";

export default function PrivacyPage() {
  return (
    <PageLayout>
      <div data-testid="privacy-page" className="pt-28 pb-20 bg-[#F6F8F3]">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <span className="eyebrow">Informativa</span>
          <h1 className="font-serif-elegant mt-6 text-4xl lg:text-5xl font-light text-[#3D3B3A] leading-tight">
            Privacy Policy
          </h1>
          <p className="mt-4 text-sm text-[#73706E]">
            Ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003 e successive modifiche.
            Ultimo aggiornamento: 18 giugno 2026.
          </p>

          <div className="mt-12 space-y-10 text-[#3D3B3A] leading-[1.85]">
            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">1. Titolare del trattamento</h2>
              <p className="text-[#73706E]">
                Il Titolare del trattamento dei dati personali è la <strong>{STUDIO.name}</strong>,
                con studio in {STUDIO.address}, {STUDIO.city}.
              </p>
              <p className="text-[#73706E] mt-2">
                Contatti: tel. <a href={`tel:${STUDIO.phoneRaw}`} className="text-[#7E9C7B] underline">{STUDIO.phone}</a> ·
                email <a href={`mailto:${STUDIO.email}`} className="text-[#7E9C7B] underline">{STUDIO.email}</a>.
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">2. Dati raccolti</h2>
              <p className="text-[#73706E]">
                Attraverso questo sito web vengono raccolti esclusivamente i dati che l&apos;utente
                fornisce volontariamente mediante:
              </p>
              <ul className="mt-3 ml-6 list-disc text-[#73706E] space-y-1">
                <li>il modulo di prenotazione online (nome, email, telefono, data e orario richiesti, eventuali note);</li>
                <li>il modulo di contatto (nome, email, telefono, messaggio);</li>
                <li>la richiesta di richiamo in giornata (nome, telefono, fascia oraria preferita).</li>
              </ul>
              <p className="text-[#73706E] mt-3">
                Non sono raccolti dati appartenenti a categorie particolari (ex art. 9 GDPR) tramite
                il sito. Eventuali dati sanitari saranno raccolti unicamente nel contesto del rapporto
                professionale, previo consenso scritto e specifico, e trattati nel rispetto del
                segreto professionale di cui all&apos;art. 622 c.p. e del Codice Deontologico degli Psicologi.
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">3. Finalità e base giuridica</h2>
              <p className="text-[#73706E]">I dati sono trattati per:</p>
              <ul className="mt-3 ml-6 list-disc text-[#73706E] space-y-1">
                <li>rispondere alle richieste di contatto e gestire le prenotazioni (base giuridica: esecuzione di misure precontrattuali — art. 6, par. 1, lett. b GDPR);</li>
                <li>adempiere ad obblighi di legge fiscali e contabili (art. 6, par. 1, lett. c GDPR);</li>
                <li>garantire la sicurezza del sito (legittimo interesse — art. 6, par. 1, lett. f GDPR).</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">4. Modalità del trattamento</h2>
              <p className="text-[#73706E]">
                Il trattamento avviene con strumenti elettronici e cartacei, con misure di sicurezza
                idonee a garantire la riservatezza dei dati. I dati raccolti tramite il sito sono
                conservati su server cloud localizzati nello Spazio Economico Europeo. Le email
                transazionali sono inviate tramite il fornitore Resend Inc.
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">5. Conservazione</h2>
              <p className="text-[#73706E]">
                I dati raccolti tramite i form di contatto e prenotazione sono conservati per il
                tempo strettamente necessario a dare riscontro alla richiesta, e comunque per un
                massimo di <strong>24 mesi</strong> dall&apos;ultimo contatto, salvo diversi obblighi di legge
                (es. fatture, per 10 anni). I dati clinici raccolti nel contesto del rapporto
                professionale sono conservati come previsto dal Codice Deontologico (almeno 5 anni
                dalla conclusione della prestazione).
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">6. Comunicazione e diffusione</h2>
              <p className="text-[#73706E]">
                I dati non sono diffusi né comunicati a terzi, fatta eccezione per i fornitori
                tecnici (hosting, invio email) che operano come Responsabili del trattamento ex
                art. 28 GDPR, e per le autorità competenti su richiesta motivata.
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">7. Diritti dell&apos;interessato</h2>
              <p className="text-[#73706E]">
                In ogni momento puoi esercitare i diritti previsti dagli artt. 15-22 GDPR: accesso,
                rettifica, cancellazione, limitazione, portabilità, opposizione al trattamento e
                revoca del consenso. Per esercitarli scrivi a{" "}
                <a href={`mailto:${STUDIO.email}`} className="text-[#7E9C7B] underline">{STUDIO.email}</a>.
              </p>
              <p className="text-[#73706E] mt-2">
                Hai inoltre diritto di proporre reclamo all&apos;Autorità Garante per la Protezione
                dei Dati Personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer" className="text-[#7E9C7B] underline">www.garanteprivacy.it</a>).
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">8. Modifiche</h2>
              <p className="text-[#73706E]">
                La presente informativa può essere aggiornata in qualsiasi momento. Le modifiche
                saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
